// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"297243af","239":"fe24cbf0","453":"bf21cdf9","667":"21faa21e"}[chunkId] + ".chunk.js";
};